<template>
  <span>
    <i class="fas fa-calendar r4"></i><code
      v-if="!gran"
    >{{new Date(unixtime).toLocaleDateString('en-US', {year: 'numeric', month: 'short', day: 'numeric' })}} {{new Date(unixtime).toLocaleTimeString('en-GB', {hour: '2-digit', minute:'2-digit'})}}</code>
    <code
      v-else-if="gran === 'minute'"
    >{{new Date(unixtime).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}} {{new Date(unixtime).toLocaleTimeString('en-GB', {hour: '2-digit', minute:'2-digit'})}}</code>
    <code v-else>
      {{new Date(unixtime).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}}</code>
  </span>
</template>

<script>
export default {
  name: "itime",
  props: {"timestamp": {type: [Number, Date, String, Object]}, "gran": {type: String}},
  computed: {
    unixtime () {
      if (typeof this.timestamp !== 'number') return +new Date(this.timestamp)
      else return this.timestamp
    }
  }
};
</script>